module.exports = {
    CHAIN: 137,
    NETWORK: "Polygon Mainnet",
    Explore: 'https://polygonscan.com/',
    SYMBOL:'POL',
    POLYGON_RPC:"https://polygon-mainnet.g.alchemy.com/v2/eqw9kf5oEAt8p0LSnS69oz1lXXQQKUW-",
    BNB_RPC:"https://bsc-mainnet.nodereal.io/v1/c17b661431254622923707e994badf58",
    AVAX_RPC:"https://open-platform.nodereal.io/c17b661431254622923707e994badf58/avalanche-c/ext/bc/C/rpc",
    ARB_RPC:"https://open-platform.nodereal.io/c17b661431254622923707e994badf58/arbitrum-nitro/",
    ETH_RPC:"https://eth-mainnet.nodereal.io/v1/c17b661431254622923707e994badf58",
    BASE_RPC:"https://open-platform.nodereal.io/c17b661431254622923707e994badf58/base",
    projectId: 'f5977011bdf8f1a31a1ea68aa2d4a606',

    ///// INFI Config  //////
    INFI_CONTRACT: "0x0CC9b5290d920bDC966E93205241D0eE07b5799f",
    INFI_DECIMAL: 18,
    TOKEN_A: {
        balance: 0,
        symbol: "INFI",
        icon: "assets/images/coin/infi.svg",
        contract:"0x0CC9b5290d920bDC966E93205241D0eE07b5799f",
    },

    //// USDT Config /////
    USDT_CONTRACT:"0xc2132D05D31c914a87C6611C10748AEb04B58e8F",
    USDT_DECIMAL: 6,
    FEE_SYMBOL: '$',
    TOKEN_B: {
        balance: 0,
        symbol: "USDT",
        icon: "assets/images/coin/usdt.svg",
        contract:"0xc2132D05D31c914a87C6611C10748AEb04B58e8F",
    },
    LIQUIDITY_CONTRACT: "0xa4cd672D3575F7C7715408b356821eb78ba777E2",
    STAKING_CONTRACT: "0x45eDe4470B55eD03D04CEDeA4286aE0C96D78A4a",
    STAKING_DURATION : '24 Months',

    USDT_BNB:"0x55d398326f99059fF775485246999027B3197955",
    USDT_AVAX:"0x9702230A8Ea53601f5cD2dc00fDBc13d4dF4A8c7",
    USDT_ARB:"0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
    USDT_ETH:"0xdAC17F958D2ee523a2206206994597C13D831ec7",
    USDT_BASE:"0xfde4C96c8593536E31F229EA8f37b2ADa2699bb2",
    RESERVE:"0xd99DF13B7720dd8DB4baA76F2067EF1866fB2C94",
    TREASURY:"0x52c436daCC05f5FFD1403167ee8872f42a46c952",

    SBSE_PFP:"0x2102c229DD7D7E34Ca5DC1a17CCaE16D021A071f",
    WBTC_POL:'0x1BFD67037B42Cf73acF2047067bd4F2C47D9BfD6',
    USDC_POL:'0x3c499c542cEF5E3811e1192ce70d8cC03d5c3359'
}
